import styled from "@emotion/styled";
import colors from "../../styles/colors";
export const ReactSelectContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;

  position: relative;
`;
export const ListItemStyled = styled.li `
  padding: 0rem;
  cursor: pointer;
`;
export const UnOrderedListStyled = styled.ul `
  font-family: Inter;
  padding: 0rem;
  margin: 0rem;
  list-style-type: none;
  max-height: 18rem;
  overflow-y: auto;
  position: absolute;
  margin-top: 0.125rem;
  width: 100%;
  border-radius: 4px;
  border: 0.078rem solid ${colors["color-gray-30"]};
  background-color: ${colors["color-white-100"]};
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  top: 3.5rem;
  z-index: 1;
`;
export const ListItemLabelStyled = styled.div `
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0rem 0.5rem;
  height: 2.25rem;
  display: flex;
  align-items: center;

  background-color: ${(props) => props.isInFocus
    ? `${colors["color-blue-30"]}`
    : `${colors["color-white-100"]}`};

  :hover {
    background-color: ${colors["color-blue-30"]};
  }

  :active {
    background-color: #b2d4ff;
  }
`;
//# sourceMappingURL=FreeTextDropdownField.styled.js.map